/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Review_TitleInputs */

const vi_einvoice_review_title = /** @type {(inputs: Einvoice_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra trước khi xuất bản`)
};

/**

* @param {Einvoice_Review_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_review_title = /** @type {((inputs?: Einvoice_Review_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Review_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_review_title(inputs)
});